// extracted by mini-css-extract-plugin
export default {"contact-seller-button":"ContactSeller_contact-seller-button__tXU0N"};